import { List, Record } from 'immutable'
import { v4 as uuid } from 'uuid'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface IDevelopmentTeamRole {
  readonly key: string
  readonly members: List<IAssociatedContact>
  readonly name: string
}

const DevelopmentTeamRoleRecord = Record({
  key: '',
  members: List<AssociatedContact>(),
  name: '',
})

export class DevelopmentTeamRole extends DevelopmentTeamRoleRecord
  implements IDevelopmentTeamRole {
  public static fromJS(initialState?: Partial<IDevelopmentTeamRole>) {
    if (!initialState) {
      return new DevelopmentTeamRole()
    }

    const { members, ...rest } = initialState

    return new DevelopmentTeamRole({
      members: members
        ? List(members.map((a) => AssociatedContact.fromJS(a)))
        : undefined,
      ...rest,
    })
  }

  public readonly key: string
  public readonly members: List<AssociatedContact>
  public readonly name: string

  constructor(initialState?: Partial<DevelopmentTeamRole>) {
    if (initialState) {
      const { key, ...props } = initialState
      super({
        key: key || uuid(),
        ...props,
      })
    } else {
      super()
    }
  }
}
